import i18n from '@/i18n';
import router from '@/router/index';
import ExpenseService from '@/api/ExpenseService';
import AttachedFileService from '@/api/AttachedFileService';

const state = {
  availableExpenses: null,
  selectedExpense: null,
};

const getters = {};

const actions = {
  resetExpense({ commit }) {
    commit('selectedExpense', null);
  },
  deleteExpensePhoto({ commit }, args) {
    return ExpenseService.getExpenseByTimeEntryIdAndExpenseId(
      args.timeEntryId,
      args.expenseId,
    )
      .then((response) => {
        let index = null;
        response.data.attachedFiles.some((attachedFile, i) => {
          if (attachedFile.id === args.photoId) {
            index = i;
            return true;
          }
          return false;
        });
        response.data.attachedFiles.splice(index, 1);
        return ExpenseService.saveExpense(args.timeEntryId, response.data);
      })
      .then(() => AttachedFileService.deleteFileById(args.photoId))
      .then(() => {
        commit(
          'alerts/setAlert',
          { msg: i18n.t('PHOTO.DELETE_CONFIRMATION_MESSAGE') },
          { root: true },
        );
        router.push(`/dashboard/time-entries/${args.timeEntryId}/expense/${args.expenseId}`);
      });
  },
  addExpensePhoto({ commit }, args) {
    return AttachedFileService.addAttachedFile(args.data).then(response => ExpenseService.getExpenseByTimeEntryIdAndExpenseId(
      args.timeEntryId,
      args.expenseId,
    )
      .then((response2) => {
        response2.data.attachedFiles.push(response.data);
        return ExpenseService.saveExpense(args.timeEntryId, response2.data);
      })
      .then(() => {
        commit(
          'alerts/setAlert',
          { msg: i18n.t('PHOTO.ADD_CONFIRMATION_MESSAGE') },
          { root: true },
        );
        router.push(`/dashboard/time-entries/${args.timeEntryId}/expense/${args.expenseId}`);
      }));
  },
  saveExpense({ commit }, args) {
    return ExpenseService.saveExpense(args.timeEntryId, args.data).then(() => {
      commit(
        'alerts/setAlert',
        { msg: i18n.t('TIME_ENTRIES.EXPENSE.SAVE_CONFIRMATION_MESSAGE') },
        { root: true },
      );
    });
  },
  deleteExpense({ commit }, args) {
    return ExpenseService.deleteExpense(args.timeEntryId, args.expenseId).then(
      () => {
        commit(
          'alerts/setAlert',
          { msg: i18n.t('TIME_ENTRIES.EXPENSE.DELETE_CONFIRMATION_MESSAGE') },
          { root: true },
        );
        router.push(`/dashboard/time-entries/${args.timeEntryId}`);
      },
    );
  },
  addExpense({ commit }, args) {
    return ExpenseService.addExpense(args.timeEntryId, args.data).then((response) => {
      commit(
        'alerts/setAlert',
        { msg: i18n.t('TIME_ENTRIES.EXPENSE.ADD_CONFIRMATION_MESSAGE') },
        { root: true },
      );
      router.push(`/dashboard/time-entries/${args.timeEntryId}/expense/${response.data.id}`);
    });
  },
  expenseTypes({ commit }) {
    return ExpenseService.getExpenseTypes().then((response) => {
      let data = [];
      data = response.data.filter(item => item.name !== 'EXPENSE_TYPE.OTHER');
      data.push(response.data.filter(item => item.name === 'EXPENSE_TYPE.OTHER')[0]);
      commit('availableExpenses', data);
    });
  },
  expense({ commit }, args) {
    return ExpenseService.getExpenseByTimeEntryIdAndExpenseId(
      args.timeEntryId,
      args.expenseId,
    ).then((response) => {
      commit('selectedExpense', response.data);
    });
  },
};

const mutations = {
  availableExpenses(state, payload) {
    state.availableExpenses = payload;
  },
  selectedExpense(state, payload) {
    state.selectedExpense = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
